import { keyframes, style } from "@vanilla-extract/css";
import { vars } from "../../styles";

const fadeIn = keyframes({
  "0%": {
    opacity: 0,
  },
  "100%": {
    opacity: 1,
  },
});

// Slide-out animation
const fadeOut = keyframes({
  "0%": {
    opacity: 1,
  },
  "100%": {
    opacity: 0,
  },
});

export const popoverContainer = style({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  minWidth: "fit-content",
  selectors: {
    "&[data-entering]": {
      animation: `${fadeIn} 100ms ease-in-out forwards`,
    },
    "&[data-exiting]": {
      animation: `${fadeOut} 100ms ease-in-out forwards`,
    },
  },
});

export const popoverOuterContainer = style({
  display: "flex",
  flexDirection: "column",
  border: vars.borders.outline,
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.surface,
  overflow: "hidden",
});

export const popoverMenuContainer = style({
  borderRadius: vars.radii.s,
  padding: vars.space["2xs"],
  minWidth: "fit-content",
  overflowY: "auto",
  selectors: {
    "&[data-focused]": {
      outline: "none",
    },
    "&[data-focus-visible]": {
      outline: "auto",
    },
  },
});
